/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceStatus } from './AttendanceStatus';
import {
    AttendanceStatusFromJSON,
    AttendanceStatusFromJSONTyped,
    AttendanceStatusToJSON,
    AttendanceStatusToJSONTyped,
} from './AttendanceStatus';

/**
 * 
 * @export
 * @interface UpdateAttendanceLogRequest
 */
export interface UpdateAttendanceLogRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAttendanceLogRequest
     */
    timeIn: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAttendanceLogRequest
     */
    timeOut: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAttendanceLogRequest
     */
    remarks: string | null;
    /**
     * 
     * @type {AttendanceStatus}
     * @memberof UpdateAttendanceLogRequest
     */
    status: AttendanceStatus;
}



/**
 * Check if a given object implements the UpdateAttendanceLogRequest interface.
 */
export function instanceOfUpdateAttendanceLogRequest(value: object): value is UpdateAttendanceLogRequest {
    if (!('timeIn' in value) || value['timeIn'] === undefined) return false;
    if (!('timeOut' in value) || value['timeOut'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UpdateAttendanceLogRequestFromJSON(json: any): UpdateAttendanceLogRequest {
    return UpdateAttendanceLogRequestFromJSONTyped(json, false);
}

export function UpdateAttendanceLogRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAttendanceLogRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'timeIn': json['timeIn'],
        'timeOut': json['timeOut'],
        'remarks': json['remarks'],
        'status': AttendanceStatusFromJSON(json['status']),
    };
}

export function UpdateAttendanceLogRequestToJSON(json: any): UpdateAttendanceLogRequest {
    return UpdateAttendanceLogRequestToJSONTyped(json, false);
}

export function UpdateAttendanceLogRequestToJSONTyped(value?: UpdateAttendanceLogRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timeIn': value['timeIn'],
        'timeOut': value['timeOut'],
        'remarks': value['remarks'],
        'status': AttendanceStatusToJSON(value['status']),
    };
}

